import styles from "./Gallery.module.css"
import PopupPicture from "./PopupPicture"
import { Image, Row, Col } from "antd"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import { Pagination, Navigation } from "swiper/modules"
import { useEffect, useState } from "react"

import indowallet from "./images/indowallet.jpg"
import kai from "./images/kai.png"
import pertamina from "./images/pertamina.jpeg"
import onlineT from "./images/online-training.jpg"
import bimtek from "./images/bimtek.jpg"
import img7314 from "./images/img7314.jpg"

import iconNext from "./assets/arrow-right-green.svg"
import iconPrev from "./assets/arrow-left-green.svg"
import iconNextDisabled from "./assets/arrow-right.svg"
import iconPrevDisabled from "./assets/arrow-left.svg"

const Gallery = () => {
  const images = [onlineT, bimtek, kai, indowallet, pertamina, img7314]

  const [isSwiper, setIsSwiper] = useState(false)
  const [slides, setSlides] = useState(1)

  const [isBeginning, setIsBeginning] = useState(true)
  const [isEnd, setIsEnd] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth

      if (width <= 767) {
        setIsSwiper(true)
        setSlides(1)
      } else if (width <= 850) {
        setIsSwiper(true)
        setSlides(2)
      } else {
        setIsSwiper(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <div className={`container ${styles.body}`} data-aos="fade-up">
      <div className={styles.topdesc}>
        <div className={styles.textWrap}>
          <h1 className={styles.header}>Galeri Partnership</h1>
          <p className={styles.desc}>
            Menangkap energi dan antusiasme dari setiap <br />
            program yang kami jalankan
          </p>
        </div>

        {isSwiper && (
          <div className={styles.btnSwiper}>
            <button
              className={`btn-prev-gal ${styles.btnPrev} ${
                !isBeginning ? styles.btnActive : ""
              }`}
              disabled={isBeginning}>
              <img src={isBeginning ? iconPrevDisabled : iconPrev} alt="prev" />
            </button>

            <button
              className={`btn-next-gal ${styles.btnNext} ${
                !isEnd ? styles.btnActive : ""
              }`}
              disabled={isEnd}>
              <img src={isEnd ? iconNextDisabled : iconNext} alt="next" />
            </button>
          </div>
        )}
      </div>

      <Image.PreviewGroup>
        {isSwiper ? (
          <Swiper
            slidesPerView={slides}
            spaceBetween={20}
            pagination={{ clickable: true }}
            navigation={{
              nextEl: ".btn-next-gal",
              prevEl: ".btn-prev-gal",
            }}
            modules={[Navigation, Pagination]}
            onSlideChange={(swiper) => {
              setIsBeginning(swiper.isBeginning)
              setIsEnd(swiper.isEnd)
            }}
            onInit={(swiper) => {
              setIsBeginning(swiper.isBeginning)
              setIsEnd(swiper.isEnd)
            }}
            className="mySwiper swiperReq">
            {images.map((image, index) => (
              <SwiperSlide key={index}>
                <PopupPicture image={image} />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <Row gutter={[24, 24]} className={styles.imgRow}>
            {images.map((image, index) => (
              <Col span={8} key={index} className={styles.column}>
                <PopupPicture image={image} />
              </Col>
            ))}
          </Row>
        )}
      </Image.PreviewGroup>
    </div>
  )
}

export default Gallery
